import {
  FETCH_BOOKING_LOCATION,
  FETCH_BOOKING_LOCATION_SUCCESS,
  FETCH_BOOKING_LOCATION_FAILED,
  STOP_LOCATION_FETCH
} from "../store/types";
import store from '../store/store';
import { getSupabase } from '../config/configureSupabase';

export const saveTracking = (bookingId, location) => {
  const supabase = getSupabase();
  if (supabase) {
    const profile = store.getState().auth?.profile;
    supabase.from('route_tracking').insert([{
      tenant_id: profile?.tenant_id,
      route_id: bookingId,
      vehicle_id: profile?.vehicle_id,
      lat: location.lat,
      lng: location.lng,
      heading: location.heading || 0,
      speed: location.speed || 0
    }]).then(({ error }) => {
      if (error) console.warn('saveTracking error:', error.message);
    });
  }
};

export const fetchBookingLocations = (bookingId) => (dispatch) => {
  const supabase = getSupabase();
  if (supabase) {
    dispatch({
      type: FETCH_BOOKING_LOCATION,
      payload: bookingId,
    });
    supabase
      .from('vehicle_locations')
      .select('*')
      .eq('route_id', bookingId)
      .maybeSingle()
      .then(({ data }) => {
        if (data) {
          dispatch({
            type: FETCH_BOOKING_LOCATION_SUCCESS,
            payload: { lat: data.lat, lng: data.lng }
          });
        }
      });
  }
};

export const stopLocationFetch = (bookingId) => (dispatch) => {
  dispatch({
    type: STOP_LOCATION_FETCH,
    payload: bookingId,
  });
};

export const saveUserLocation = (location) => {
  const supabase = getSupabase();
  if (supabase) {
    const profile = store.getState().auth?.profile;
    const uid = profile?.id || profile?.uid;
    if (uid && profile?.tenant_id) {
      supabase.from('vehicle_locations').upsert({
        vehicle_id: profile.vehicle_id || uid,
        tenant_id: profile.tenant_id,
        driver_id: uid,
        lat: location.lat,
        lng: location.lng,
        heading: location.heading || 0,
        speed: location.speed || 0,
        updated_at: new Date().toISOString()
      }).then(({ error }) => {
        if (error) console.warn('saveUserLocation error:', error.message);
      });
    }
  }
};